import { CruisePurchaseModel } from 'api-hooks/order/cruise';
import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, FormState, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { ButtonContainer, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../../style';
import { CruisePurchaseFormType } from '../form-type';

export default function SummaryCruisePurchase(props: {
  cruisePurchase?: CruisePurchaseModel;
}) {
  const { t } = useTranslation();
  const drawer = useDrawer();
  const methods = useFormContext<CruisePurchaseFormType>();
  const {
    formState: { isSubmitting },
    reset,
    clearErrors,
  } = methods;

  const { total } = useRecalculate();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={close} />
        </Form>
      ),
    });
  }, [drawer, methods]);

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_order')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}>
          {`Rp. ${string2money(total)}`}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <FormState>
        {({ editable, setIsEditable }) => (
          <SummaryRightContainer>
            {editable && props.cruisePurchase && !isSubmitting && (
              <>
                <ButtonContainer style={{ marginLeft: '16px' }}>
                  <Button
                    buttonType="secondary"
                    startEnhancer={(color, size) => (
                      <CloseSVG width={size} height={size} color={color} />
                    )}
                    onClick={() => {
                      reset();
                      clearErrors();
                      setIsEditable(false);
                    }}
                  >
                    {t('common:cancel')}
                  </Button>
                </ButtonContainer>
                <SeparatorHorizontal $margin={24} />
              </>
            )}
            <Input
              type="submit"
              overrides={{
                Root: {
                  style: {
                    flex: 1,
                  },
                },
              }}
            />
          </SummaryRightContainer>
        )}
      </FormState>
    </SummaryContent>
  );
}
